// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## File GetFile
/**
 *
 * @param { filePath: string, iscCompress: boolean} form
 *
 * @returns
 */
export const GetFile = async (form) => {
  const response = await $api.post(Endpoints.File.Get(), form);
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## File GetReceipt
/**
 *
 * @param { saleId: string } form
 *
 * @returns
 */
export const GetReceipt = async (form) => {
  const response = await $api.post(Endpoints.File.GetReceipt(), form);
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  GetFile,
  GetReceipt,
};
